export const GET_LEAD_CAPTURE_DATA = "/bot/v2/integrations/email/leads/integrate";
export const POST_LEAD_CAPTURE_DATA = "/bot/v2/integrations/email/leads/integrate";
export const PUT_LEAD_CAPTURE_DATA = "/bot/v2/integrations/email/leads/integrate";
export const DELETE_LEAD_CAPTURE_DATA = "/bot/v2/integrations/email/leads/integrate";